import React, { useEffect, useState } from 'react';
import { Card, Container, Row, Col, Button, Badge } from 'react-bootstrap';
import './BuyerConfirmedBids.css'; // CSS is added below

export default function BuyerConfirmedBids() {
  const [confirmedBids, setConfirmedBids] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const user = JSON.parse(sessionStorage.getItem('user'));
  const userId = user?.id;

  useEffect(() => {
    const fetchConfirmedBids = async () => {
      try {
        const bidRes = await fetch(`https://vyaparapi.emedha.in/api/buyer/bids/by-user/${userId}`);
        const userBids = await bidRes.json();

        const results = [];

        for (const bid of userBids) {
          const res = await fetch(`https://vyaparapi.emedha.in/api/seller/bids/by-bid-id/${bid.bid_id}`);
          const sellerBids = await res.json();

          if (Array.isArray(sellerBids) && sellerBids.length > 0) {
            const topThree = [...sellerBids]
              .sort((a, b) => parseFloat(a.seller_offer) - parseFloat(b.seller_offer))
              .slice(0, 3);

            results.push({
              bid,
              topThree
            });
          }
        }

        setConfirmedBids(results);
        console.log("results",results)
      } catch (err) {
        console.error('❌ Error fetching confirmed bids:', err);
      }
    };

    if (userId) fetchConfirmedBids();
  }, [userId]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const getSellerTimeLeft = (sellerCreatedAt) => {
    const offerTime = new Date(sellerCreatedAt);
    const expiryTime = new Date(offerTime.getTime() + 180 * 60 * 1000);
    const diff = expiryTime - currentTime;

    if (diff <= 0) return { expired: true };

    const minutes = Math.floor(diff / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    return { minutes, seconds, expired: false };
  };


  const handleAcceptBid = async (bidId, offerId, amount) => {
  const confirm = window.confirm(`Confirm accepting this offer of ₹${amount}?`);
  if (!confirm) return;

  try {
    const res = await fetch('https://vyaparapi.emedha.in/api/buyer/accept-bid', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ bidId, offerId }),
    });

    const data = await res.json();
    alert(data.message);

    // Optionally reload confirmed bids
    window.location.reload(); // or re-trigger fetchConfirmedBids()
  } catch (err) {
    console.error('Error accepting bid:', err);
    alert('Something went wrong. Try again.');
  }
};


  return (
    <Container className="my-5 buyer-confirmed-bids">
      <h3 className="section-title text-center mb-4">
        🎯 Seller Confirmed Bids
      </h3>

      {confirmedBids.length === 0 ? (
        <p className="text-center text-muted">No confirmed seller bids found.</p>
      ) : (
       confirmedBids
  .filter((entry) =>
    entry.topThree.some((offer) => offer.status === 'pending')
  )
  .map(({ bid, topThree }, i) => (
          <Card className="bid-card mb-5" key={i}>
            <Card.Body>
              <h5 className="mb-3 text-primary">
                <strong>🆔 Bid ID:</strong> {bid.bid_id}
              </h5>
              <Row className="mb-2">
                <Col md={6}><strong>📦 Category:</strong> {bid.category} / {bid.sub_category}</Col>
                <Col md={6}><strong>💰 Price Range:</strong> ₹{bid.price_from} - ₹{bid.price_to}</Col>
              </Row>
              <Row>
                <Col md={6}><strong>🔧 Warranty:</strong> {bid.warranty}</Col>
                <Col md={6}><strong>🧩 Specs:</strong> {bid.selected_specs}</Col>
              </Row>
              <p className="text-muted mt-2">🕒 Created: {new Date(bid.created_at).toLocaleString()}</p>

              <h6 className="text-secondary mt-4">Top 3 Lowest Seller Offers</h6>
              <Row>
                {topThree.map((offer) => {
                  const { expired, minutes, seconds } = getSellerTimeLeft(offer.created_at);
                  return (
                    <Col md={4} key={offer.id} className="mt-3">
                      <Card className="offer-card text-center h-100">
                        <Card.Body>
                          <h5 className="offer-price">₹{offer.seller_offer}</h5>
                          <p className="text-muted small">🕒 {new Date(offer.created_at).toLocaleString()}</p>
                          <Badge bg={expired ? 'danger' : 'success'} className="mb-2">
                            {expired
                              ? '⛔ Expired'
                              : `⏳ ${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} left`}
                          </Badge>
                          <br />
                         <Button
  variant="danger"
  size="sm"
  disabled={expired || offer.status === 'accepted' || offer.status === 'rejected'}
  onClick={() => handleAcceptBid(bid.bid_id, offer.id, offer.seller_offer)}
>
  Accept
</Button>

                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </Card.Body>
          </Card>
        ))
      )}
    </Container>
  );
}
